import * as cadastral from '@/api/cadastral'

export const TIPOS = [
  { tipo: 'clt', nome: 'CLT' },
  { tipo: 'gov', nome: 'Servidor Estadual' },
  { tipo: 'pref', nome: 'Servidor Municipal' }
]

const state = {
  // consultas ja realizadas, indexadas por tipo
  dados: {},
  tipoSelecionado: null
}

const getters = {
  consultados: state => Object.keys(state.dados),
  selecionado: state => state.tipoSelecionado ? state.dados[state.tipoSelecionado] : null
}

const mutations = {
  SET (state, payload) {
    state.dados = payload
  },
  SETTIPO (state, payload) {
    state.tipoSelecionado = payload
  },
  SETCONSULTA (state, payload) {
    state.dados = Object.assign({}, state.dados, { [payload.tipo]: payload })
  }
}

function montaItem (tipo) {
  const encontrado = TIPOS.find(t => t.tipo === tipo)
  return {
    identificacao: `cadastral_${tipo}`,
    nome: encontrado ? encontrado.nome : tipo.toUpperCase()
  }
}

const actions = {
  // Carrega o que ja foi consultado, para exibir sem consultar de novo
  async get (context, registro) {
    let data = await cadastral.buscar(registro)
    let instancia = data.instancia

    let dados = {}
    if (instancia && instancia.length) instancia.forEach(c => { dados[c.tipo] = c })

    context.commit('SET', dados)
    context.dispatch('pedido/setCadastral', Object.keys(dados).length ? dados : false, { root: true })

    return dados
  },

  // Dispara a consulta no fornecedor, consumindo pacote
  async consultar (context, { tipo, registro }) {
    let data = await cadastral.consultar(tipo, registro)
    let instancia = data.instancia

    if (!instancia) throw new Error('Não foi possível consultar os dados.')

    context.commit('SETCONSULTA', instancia)
    context.dispatch('pedido/setCadastral', context.state.dados, { root: true })

    return montaItem(tipo)
  },

  selecionaTipo (context, tipo) {
    context.commit('SETTIPO', tipo)
  },

  async clear (context) {
    context.commit('SET', {})
    context.commit('SETTIPO', null)
    context.dispatch('pedido/setCadastral', false, { root: true })
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/cadastral.js